<template>
  <a
    :href="product.link"
    class="product-card"
    :class="{
      'product-card_active': isActive
    }"
    @touchstart="isActive = true"
    @touchend="isActive = false"
  >
    <div class="product-card__bg">
      <img
        src="@/assets/new-design/img/index/promo/product-card-bg.webp"
        alt=""
        width="367"
        height="116"
      />
    </div>
    <div class="product-card__content">
      <span class="product-card__title">{{ product.title }}</span>
      <p class="product-card__description" v-html="product.description_mobile"></p>
    </div>
    <picture class="product-card__logo">
      <source
        :srcset="require(`@/assets/new-design/img/products/coin/${product.image}.webp`)"
      />
      <img
        :src="`@/assets/new-design/img/products/coin/${product.image}.png`"
        alt=""
        width="56"
        height="56"
      />
    </picture>
  </a>
</template>

<script>
export default {
  name: "MainPromoProductListItemMobile",
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isActive: false
    }
  }
}
</script>

<style scoped lang="scss">
.product-card {
  position: relative;
  padding: 16px;
  border-radius: 20px;
  text-decoration: none;
  text-align: left;
  background-color: $color-gray-2;
  overflow: hidden;
  transition: transform 0.2s ease-in-out;

  &_active {
    transform: scale3d(0.988, 0.955, 0.988);
  }

  &__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__logo {
    position: absolute;
    right: 0;
    top: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  &__title {
    font-family: $font-mts-wide;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: $color-dark-2;
    text-transform: uppercase;
  }

  &__description {
    font-family: $font-mts-compact;
    font-size: 17px;
    line-height: 24px;
    color: $color-gray-1;
  }
}
</style>
